import{formatRasanaRelease}from'./releaseInfo';

declare const __RASANA_VERSION__:string;
declare const __RASANA_RELEASE_CHANNEL__:string;
declare const __RASANA_RELEASE_ID__:string;

/** Values are embedded in the same Vite build as the displayed application. */
export const RASANA_BUILD=formatRasanaRelease(
 __RASANA_VERSION__,__RASANA_RELEASE_CHANNEL__,__RASANA_RELEASE_ID__
);
